<template>
  <div class="guest-modal">
    <div class="modal">
      <div class="image">
        <img src="/how/04.svg" alt="Logo flagship">
        ¿Listo para invertir?
      </div>
      <div class="content">
        <div class="content-text-container">
          <div class="content-text">
            <div class="header">
              Déjanos tu correo
            </div>
            <div class="description">
              Sé el primero en enterarte cuando este proyecto esté disponible para invertir, así como
              de todas las novedades que tenemos para ti.
            </div>
            <div class="label label--name">
              <div class="label-text">Nombre</div>
              <BaseInput v-model="data.name" />
            </div>
            <div class="label label--name">
              <div class="label-text">Apellido(s)</div>
              <BaseInput v-model="data.lastName" />
            </div>
            <div class="label label--email">
              <div class="label-text">Correo electrónico</div>
              <BaseInput v-model="data.email" />
            </div>
            <div class="button-container">
              <div class="button" @click="subscribe">
                Suscribirse
              </div>
            </div>
          </div>
        </div>
        <div class="account-actions">
          ¿Prefieres usar tu cuenta de Flagship?
          <br><a href="/register">Regístrate</a> o <a :href="`/login?redirect=${$route.path}`">inicia sesión</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import BaseInput from '@/components/base/BaseInput.vue';

const { mapActions } = createNamespacedHelpers('user');

export default {
  data() {
    return {
      data: {
        name: null,
        lastName: null,
        email: null,
      },
    };
  },
  components: {
    BaseInput,
  },
  methods: {
    async subscribe() {
      await this.subscribeToProject({
        name: this.data.name,
        lastName: this.data.lastName,
        email: this.data.email,
        projectId: this.$route.params.projectId,
      });
      this.$emit('closeModal');
    },
    ...mapActions([
      'subscribeToProject',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.guest-modal {
  width: 100vw;
  height: 100vh;
  position: fixed;
  background-color: rgba(255, 255, 255, 0.918);
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal {
  width: 800px;
  background-color: white;
  box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
  padding: 20px 35px;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
}
.image {
  width: 38%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: rgb(160, 160, 160);

  img {
    width: 100%;
    height: auto;
    margin-bottom: 14px;
  }
}
.content {
  width: 55%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.content-text-container {
  flex-grow: 1;
  display: flex;
  align-items: center;
  width: 100%;
}
.content-text {
  width: 100%;
  padding: 25px 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.header {
  font-size: 28px;
  font-weight: 500;
  margin-bottom: 18px;
}
.description {
  font-size: 15px;
  line-height: 1.4;
}
.account-actions {
  margin-top: 16px;
  font-size: 14px;
  line-height: 1.5;

  a {
    color: #3479e9;
  }
}
.label {
  width: 100%;
  margin-top: 16px;
}
.label--email {
  width: 70%;
}
.label--name {
  width: 48%;
}
.label-text {
  line-height: 18px;
  margin-bottom: 12px;
  font-weight: 500;
}
.button-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}
.button {
  background-color: #3479e9;
  color: white;
  padding: 12px 30px;
  display: flex;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
}
@media only screen and (max-width: 860px) {
  .modal {
    width: 96%;
  }
  .image {
    width: 28%;
  }
  .content {
    width: 70%;
  }
}
@media only screen and (max-width: 670px) {
  .content {
    width: 100%;
  }
  .image {
    display: none;
  }
}
@media only screen and (max-width: 570px) {
  .label--name {
    width: 100%
  }
  .label--email {
    width: 100%
  }
}
@media only screen and (max-width: 450px) {
  .modal {
    padding: 20px;
  }
}

</style>
